var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 288.147,
    height: 252.472,
    viewBox: "0 0 288.147 252.472",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12786",
    "data-name": "Rectangle 12786",
    width: 288.147,
    height: 252.472,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_856",
    "data-name": "Group 856",
    transform: "translate(-1732.201 -15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_830",
    "data-name": "Group 830",
    transform: "translate(1732.201 15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_829",
    "data-name": "Group 829",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11417",
    "data-name": "Path 11417",
    d: "M141.585,146.376v0l16.075,25.777",
    transform: "translate(22.923 23.699)",
    fill: "#ea3901"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_202",
    "data-name": "Line 202",
    x1: 0.002,
    transform: "translate(67.722)",
    fill: "#ea3901"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11418",
    "data-name": "Path 11418",
    d: "M112.018,44.03H87.106A3.071,3.071,0,0,1,84.5,42.583q-6.55-10.494-13.09-20.99a3.071,3.071,0,0,1,2.606-4.7H98.929a3.07,3.07,0,0,1,2.606,1.447q6.543,10.494,13.088,20.989a3.071,3.071,0,0,1-2.605,4.7",
    transform: "translate(11.485 2.736)",
    fill: "#ea3901"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11419",
    "data-name": "Path 11419",
    d: "M127.748,172.158q8.038-12.889,16.077-25.779v0",
    transform: "translate(20.683 23.699)",
    fill: "#ea3901"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11420",
    "data-name": "Path 11420",
    d: "M143.823,194.345q-8.038-12.888-16.075-25.779",
    transform: "translate(20.683 27.291)",
    fill: "#ea3901"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11421",
    "data-name": "Path 11421",
    d: "M157.66,168.563q-8.038,12.892-16.077,25.782",
    transform: "translate(22.923 27.291)",
    fill: "#ea3901"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11422",
    "data-name": "Path 11422",
    d: "M141.3,201.579l-13.177,21.129a2.46,2.46,0,0,1-4.176,0q-6.586-10.564-13.176-21.129a2.463,2.463,0,0,1,0-2.6l13.178-21.129a2.46,2.46,0,0,1,4.176,0q6.588,10.563,13.175,21.129a2.459,2.459,0,0,1,0,2.6",
    transform: "translate(17.874 28.606)",
    fill: "#ea3901"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11423",
    "data-name": "Path 11423",
    d: "M159.091,172.878l-13.177,21.129a2.46,2.46,0,0,1-4.176,0l-13.176-21.129a2.463,2.463,0,0,1,0-2.6l13.178-21.129a2.46,2.46,0,0,1,4.176,0q6.588,10.563,13.175,21.129a2.459,2.459,0,0,1,0,2.6",
    transform: "translate(20.754 23.959)",
    fill: "#ea3901"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11424",
    "data-name": "Path 11424",
    d: "M158.352,157.47a3.321,3.321,0,0,1,0,3.514q-7.494,12.01-14.982,24.022-2.262,3.623-4.519,7.247-6.632,10.63-13.261,21.262a3.32,3.32,0,0,1-5.634,0q-6.628-10.63-13.261-21.262-2.206-3.545-4.418-7.086Q60.785,118.631,19.289,52.091q-2.454-3.942-4.914-7.881Q7.442,33.094.509,21.973A3.319,3.319,0,0,1,3.325,16.9H27.654a3.323,3.323,0,0,1,2.818,1.563Q38.5,31.334,46.53,44.21l4.915,7.881Q84.9,105.738,118.354,159.386l4.421,7.088,4.517-7.247,13.261-21.263a3.32,3.32,0,0,1,5.634,0q6.083,9.753,12.165,19.506",
    transform: "translate(0 2.736)",
    fill: "#ea3901"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11425",
    "data-name": "Path 11425",
    d: "M132.267,127.933q-6.285,10.079-12.573,20.16a2.973,2.973,0,0,1-5.046,0q-29.934-48-59.868-96L49.865,44.21q-7.1-11.383-14.2-22.766A2.973,2.973,0,0,1,38.191,16.9H63.337a2.974,2.974,0,0,1,2.524,1.4Q73.939,31.252,82.02,44.21q2.457,3.942,4.914,7.881,22.671,36.344,45.333,72.7a2.972,2.972,0,0,1,0,3.146",
    transform: "translate(5.701 2.736)",
    fill: "#ea3901"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11426",
    "data-name": "Path 11426",
    d: "M179.267,18.262,168.731,1.371A2.91,2.91,0,0,0,166.261,0H140.969A2.912,2.912,0,0,0,138.5,4.452q4.734,7.59,9.468,15.18h-36.1a2.911,2.911,0,0,0-2.471,4.451q7.128,11.431,14.257,22.862,2.459,3.941,4.915,7.88Q139.1,71.733,149.651,88.643q2.208,3.545,4.421,7.088-2.259,3.618-4.511,7.233-2.212-3.543-4.421-7.086L120.4,56.2a2.91,2.91,0,0,0-2.47-1.371H92.635a2.912,2.912,0,0,0-2.47,4.452q19.452,31.188,38.9,62.378,2.212,3.545,4.421,7.088,8.036,12.888,16.077,25.779,2.527,4.057,5.06,8.115l13.6,21.815a2.911,2.911,0,0,0,4.94,0q6.323-10.138,12.646-20.278a2.91,2.91,0,0,0,0-3.081q-7.561-12.118-15.116-24.24-2.531-4.057-5.06-8.114,2.257-3.615,4.511-7.232,7.557-12.118,15.116-24.238a2.912,2.912,0,0,0,0-3.081Q177.7,82.07,170.147,69.951l-4.421-7.088q-2.5-4.019-5.011-8.038-2.459-3.941-4.914-7.88H165q2.454,3.941,4.914,7.88c.138.222.274.443.414.663q2.206,3.545,4.42,7.086,8.038,12.888,16.076,25.78,2.531,4.057,5.06,8.115,6.8,10.907,13.606,21.817a2.912,2.912,0,0,0,4.942,0q6.8-10.91,13.607-21.821,15.44-24.759,30.881-49.521,7.13-11.43,14.258-22.862a2.912,2.912,0,0,0-2.471-4.451H181.737a2.912,2.912,0,0,1-2.47-1.371m32.694,52.426q-2.531-4.057-5.06-8.115l-4.832-7.748q-2.457-3.941-4.914-7.88h29.612q-7.4,11.871-14.806,23.742",
    transform: "translate(14.526 0)",
    fill: "#ea3901"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_203",
    "data-name": "Line 203",
    x1: 0.002,
    transform: "translate(67.722)",
    fill: "#ea3901"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11427",
    "data-name": "Path 11427",
    d: "M22.094,0,18.628,8.624,15.2,0H7.345L3.859,14.137h6.766l1.162-8.473,4.3,8.473H21.16l4.334-8.473,1.162,8.473h6.766L29.935,0Z",
    transform: "translate(0.625)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11428",
    "data-name": "Path 11428",
    d: "M45.75,0H38.262L29.9,14.136h7L38.015,11.8h7.766l1.082,2.334h7.179ZM39.476,8.749l2.439-5.084,2.417,5.084Z",
    transform: "translate(4.842)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11429",
    "data-name": "Path 11429",
    d: "M52.256,0V3.027H63.342L51.052,14.164H72.068V11.137H61.52L73.933.021Z",
    transform: "translate(8.265)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11430",
    "data-name": "Path 11430",
    d: "M85.689,0H78.2L69.843,14.136h7L77.958,11.8h7.767l1.081,2.334h7.177ZM79.408,8.749l2.449-5.084,2.406,5.084Z",
    transform: "translate(11.308)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11431",
    "data-name": "Path 11431",
    d: "M104.85,0l-4.457,4.765L95.9,0H88.291l8.635,8.226v5.932H103.8V8.226L112.4,0Z",
    transform: "translate(14.295)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11432",
    "data-name": "Path 11432",
    d: "M122.343,0h-7.488L106.5,14.136h6.993l1.118-2.334h7.766l1.082,2.334h7.176Zm-6.274,8.749,2.442-5.084,2.417,5.084Z",
    transform: "translate(17.243)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.90bb2eaabb48a944c772655dd4f21b0e.svg";
export { ForwardRef as ReactComponent };